import {
  RESET_ITEM_EXCHANGE_INFO,
  SWITCH_CURRENT_EXCHANGE_ITEM_ID,
  UPDATE_ITEM_EXCHANGE_INFO,
  UPDATE_INVENTORY_INFO_ERROR,
  TOGGLE_EXCHANGE_SIDEBAR,
  UPDATE_EXCHANGE_COMMENT,
  SET_IS_FETCHING_INVENTORY,
} from '../../actions/exchange';

export const initialState = {
  exchangeSideBarOpen: false,
  currentExchangeItemId: null,
  items: {},
  isFetchingInventory: false,
};

export default (
  state = initialState,
  {
    type,
    data: {
      itemId,
      inventory,
      options,
      exchangeOptions,
      isOpen,
      comment,
      isFetchingInventory,
    } = {},
  } = {},
) => {
  switch (type) {
    case RESET_ITEM_EXCHANGE_INFO: {
      const updatedState = {
        ...state,
      };
      delete updatedState.items[itemId];

      return updatedState;
    }

    case SWITCH_CURRENT_EXCHANGE_ITEM_ID:
      return {
        ...state,
        currentExchangeItemId: itemId,
      };

    case UPDATE_ITEM_EXCHANGE_INFO:
      return {
        ...state,
        items: {
          ...state.items,
          [itemId]: {
            inventory,
            options,
            exchangeOptions,
            exchangeComment: '',
            inventoryError: false,
          },
        },
      };

    case UPDATE_INVENTORY_INFO_ERROR:
      return {
        ...state,
        items: {
          ...state.items,
          [itemId]: {
            inventory: [],
            options: [],
            exchangeOptions: {},
            exchangeComment: '',
            inventoryError: true,
          },
        },
      };

    case TOGGLE_EXCHANGE_SIDEBAR:
      return {
        ...state,
        exchangeSideBarOpen: isOpen,
      };

    case UPDATE_EXCHANGE_COMMENT:
      return {
        ...state,
        items: {
          ...state.items,
          [itemId]: {
            ...state.items[itemId],
            exchangeComment: comment,
          },
        },
      };

    case SET_IS_FETCHING_INVENTORY:
      return {
        ...state,
        isFetchingInventory,
      };

    default:
      return state;
  }
};
